import ApprovalStatus from '@shared/components/atoms/ApprovalStatus';
import { formatDate } from '@shared/utils/formatDate';
import styles from '@pages/approval-box/DrafterPage.module.scss';

// 테이블 데이터 정의
export const tableColumns = [
  {
    key: 'docType',
    label: '문서유형',
    width: '100px',
    className: styles.colDocumentType,
  },
  {
    key: 'docNumber',
    label: '문서번호',
    width: '200px',
    className: styles.colDocumentNumber,
  },
  {
    key: 'title',
    label: '문서제목',
    width: '250px',
    className: styles.colDocumentTitle,
  },
  {
    key: 'date',
    label: '기안일자',
    width: '150px',
    className: styles.colDraftDate,
    render: (row) => {
      return formatDate(row);
    },
  },
  {
    key: 'team',
    label: '기안부서',
    width: '120px',
    className: styles.colDraftDepartment,
  },
  {
    key: 'name',
    label: '기안자',
    width: '100px',
    className: styles.colDrafter,
  },
  {
    key: 'state',
    label: '문서상태',
    width: '120px',
    className: styles.colDocumentStatus,
    render: (value, item) => {
      const isCompleted = item.exeState === 1 || item.exeState === '1';

      return (
        <div className={styles.statusCell}>
          <ApprovalStatus variant={isCompleted ? 'gray' : undefined}>{value}</ApprovalStatus>
        </div>
      );
    },
  },
];
